import * as React from "react";
import { useEffect, useState, useContext } from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import "react-confirm-alert/src/react-confirm-alert.css";
/*
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
*/

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers'

import Modal from '@mui/material/Modal';

/* Minhas Classes */
import Contrato from "../../components/classes/Contrato";
import Parceiro from "../../components/classes/Parceiro";
import ContratoItem from "../../components/classes/ContratoItem";
import ForecastDataset from "../../components/data/ForecastDataSet";
import ContratoDataset from '../../components/data/ContratoDataSet';
import { confirmAlert } from "react-confirm-alert";

/* Meus Componentes */
import ContratoTopo from "./topo";
import TopoItemContrato from "./topoItemContrato";
import ContratoItemGrid from "./ContratoItemGrid";
import { hasInCache } from "../../helper/cacheHelper";
import AutocompleteSku from "../../components/common/AutocompleteSku";
import AutocompleteCentro from '../../components/common/AutocompleteCentro';
import AutocompleteCentroCentroVirtual from '../../components/common/AutocompleteCentroVirtual';
import PageHelper from '../../helper/pageHelper';

/* TOOLBAR */
import IconButton from "@mui/material/IconButton";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip } from "@mui/material";
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import EraseIcon from "@mui/icons-material/Delete";
import AppsIcon from '@mui/icons-material/Apps';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

/* Localização */
import br from "date-fns/locale/pt-BR";


/* SELECAO */
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import ContratoItemDataset from "../../components/data/ContratoItemDataSet";
import Box from '@mui/material/Box';

//import PageHelper from "../../helper/pageHelper";

/* LOCALIZAÇÃO */
import { format } from 'date-fns';
import { pt } from 'date-fns/locale';
import { AssignmentReturn, PlaylistAdd } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ProjetoDataset from "../../components/data/ProjetoDataSet";
import Projeto from "../../components/classes/Projeto";
import Usuario from "../../components/classes/Usuario";
import UsuarioDataset from "../../components/data/UsuarioDataSet";
import { UserContext } from "../../App";
import Utils from "../../helper/utils";

import styles from './detail.module.css';

import { useTranslation } from "react-i18next";

export const ContratoDetalhe = () => {
  const { t } = useTranslation();
  /* Forçar Renderização */
  const [contrato, setContrato] = useState(new Contrato());
  const [contratoItem, setContratoItem] = useState(new ContratoItem());
  const [projetos, setProjetos] = useState<Projeto[]>([]);

  const user: any = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const dataContrato: ContratoDataset = new ContratoDataset();
  const dataForecast: ForecastDataset = new ForecastDataset();
  const dataContratoItem: ContratoItemDataset = new ContratoItemDataset();
  const dataProjeto: ProjetoDataset = new ProjetoDataset();

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [gerouForecast, setGerouForecast] = useState(false);

  const [openMsg, setOpenMsg] = useState(true);
  const [ICSKU, setICSKU] = useState(0);
  const [ICCENTRO, setICENTRO] = useState(0);
  const [ICANO, setICANO] = useState((new Date()).getFullYear());
  const [ICQTDE, setICQTDE] = useState<string>("");
  const [multaAcordada, setMultaAcordada] = useState<string>("");
  const [contratoSap, setContratoSap] = useState("");
  const [origin, setOrigin] = useState("");
  const [projeto, setProjeto] = useState<{ id: number; nome: string } | null>(null);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleOpenDialogDelete = () => setOpenDialogDelete(true);
  const handleCloseDialogDelete = () => setOpenDialogDelete(false);

  useEffect(() => {
    if (hasInCache(dataContrato.getKeyCacheClass())) {
      dataContrato.RecuperarContratoPorParceiroENumero(Number(dataContrato.RecuperarObjetoDoCache().codigoFornecedorSAP), String(dataContrato.RecuperarObjetoDoCache().numeroContrato))
        .then((result) => {
          setContrato(result);
          Utils.setDocumentTitle(result.numeroContrato.valueOf(), `- ${t("pages.contracts.text.contract")}`);
        })
    }
    else {
      var _contrato: Contrato = new Contrato();
      _contrato.codigoFornecedorSAP = Number.parseInt(String(localStorage.getItem("CodigoFornecedorSAPSelecionado")));
      _contrato.grupo = String(localStorage.getItem("GrupoParceiroSelecionado"));
      setContrato(_contrato);
    }

    if (hasInCache(dataProjeto.getKeyCach())) {
      setProjetos(dataProjeto.ListarFromCache());
    } else {
      dataProjeto.ListarAtivos().then((response) => {
        if (response) {
          setProjetos(response);
        }
      });
    }
  }, [])

  function round3(value: number) {
    return value ? stripZeros(value.toFixed(3)) : 0;
  }

  function stripZeros(str: string) {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  }

  useEffect(() => {
    if (contrato.multaAcordada) {
      setMultaAcordada(String(round3(contrato.multaAcordada as number)));
    }
    contrato.itensContrato.forEach((item: ContratoItem) => {
      if (item.gerouForecast === true) {
        setGerouForecast(true);
      }
    })
  }, [contrato]);

  const Mensagem = (titulo: string, mensagem: string, refresh: boolean = true, redirect: boolean = false) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [{
        label: "Ok", onClick: () => {
          setOpen(false);
          if (refresh) {
            PageHelper.refreshPage();
          } else if (redirect) {
            navigate('/planejamento/contratos');
          }
        }
      }]
    });
  };

  /* Eventos do Formulário de Contrato */

  const handlerNumeroContratoChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setContrato((previousState) => {
      return { ...previousState, numeroContrato: e.target.value };
    });
  };

  const handlerFrequenciaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContrato((previousState) => {
      return { ...previousState, freqAtualPrecM: Number(e.target.value) };
    });
  };

  const handlermultaAcordadaChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newValue = e.target.value;
    setMultaAcordada(newValue);
  };

  const Alert = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [{
        label: "Ok", onClick: () => {
          setOpen(false);
        }
      }]
    });
  };

  const VerifyDataVigencia = () => {
    if (contrato.inicioVigencia < contrato.finalVigencia) {
      SalvarContrato()
    } else {
      Alert(t("common.warning"), t("pages.contracts.text.warningStartDate"))
    }
  }

  const handlerInicioVigenciaChange = (value: any) => {
    if (value) {
      try {
        let newDate: Date = new Date(value);
        if (newDate) {
          setContrato((previousState) => {
            return { ...previousState, inicioVigencia: newDate };
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const handlerFimVigenciaChange = (value: any) => {
    if (value) {
      try {
        let newDate: Date = new Date(value);
        if (newDate) {
          setContrato((previousState) => {
            return { ...previousState, finalVigencia: newDate };
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const handlerFreteChange = (event: SelectChangeEvent<String>) => {
    setContrato((previousState) => {
      return { ...previousState, modalidadeFrete: event.target.value };
    });
  };

  const handlerProjetoChange = (event: SelectChangeEvent<String>) => {
    const find = projetos.find(proj => proj.nome === String(event.target.value));
    setProjeto(find ? { id: Number(find.id), nome: find.nome } : null);
  };

  const handlerLostFocusContrato = () => {
    if (contrato.id === 0)
      dataContrato.RecuperarContratoPorParceiroENumero(Number(contrato.codigoFornecedorSAP), String(contrato.numeroContrato))
        .then((result) => {
          if (result !== null && result !== undefined && result.id.valueOf() > 0)
            alert(t("pages.contracts.text.warningContractNumber"));
        });
  }

  const SalvarContrato = () => {

    //  if (erroInicioVigencia || erroFinalVigencia || erroFrete ||
    //    erroMulta || erroPreco || erroContrato) {
    //    Mensagem("Salvar Contrato", "Alguns campos não foram preenchidos ou apresentam inconformidade. favor Corrigir!");
    //  }
    //   else {
    var refresh: boolean = true;
    if (multaAcordada) {
      contrato.multaAcordada = toNumber(multaAcordada);
    }
    if (contrato.id === 0) {
      if (!contrato.numeroContrato) {
        Mensagem(t("pages.contracts.text.saveContract"), t("pages.contracts.text.informContractNumber"), false, false);
        return;
      }
      dataContrato.Adicionar(contrato)
        .then((result) => {
          setContrato(result);
          dataContrato.AdicionarObjetoAoCache(result);
          // console.log(JSON.stringify(result));
          // refresh = false;
        });
    }
    else {
      dataContrato.Atualizar(contrato);
    }
    Mensagem(t("pages.contracts.text.saveContract"), t("pages.contracts.text.saveWithSuccess"), refresh);
    // }
  }

  const ExcluirContrato = () => {
    setLoading(true);
    dataContrato.Apagar(contrato).then((result) => {
      if (result) {
        Mensagem(t("pages.projects.text.excludeContract"), t("pages.projects.text.excludeWithSuccess"), false, true);
      } else {
        Mensagem(t("pages.projects.text.excludeContract"), t("pages.projects.text.excludeError"), false);
      }
      setLoading(false);
      setOpenDialogDelete(false);
    }).catch((erro) => {
      Mensagem(t("pages.projects.text.excludeContract"), t("pages.projects.text.excludeError"), false);
      setLoading(false);
      setOpenDialogDelete(false);
    });

  }

  /* MODAL */
  const handlercontratoItemCentroDistribuicaoChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setICENTRO(Number(e.target.value));
  };

  const handlercontratoItemanoRefChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setICANO(Number(e.target.value));
  };

  const handlercontratoItemQuantidadeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    // const value = e.currentTarget.value;
    setICQTDE(e.target.value);
  };

  function toNumber(str: string): number {
    return parseFloat(str.replace(".", "").replace(",", "."));
  }

  const modalSalvar = () => {
    let _contratoItemToAdd: ContratoItem = new ContratoItem();
    _contratoItemToAdd.id = 0;
    _contratoItemToAdd.numeroContrato = String(contrato.numeroContrato);
    _contratoItemToAdd.codigoFornecedorSap = contrato.codigoFornecedorSAP;
    _contratoItemToAdd.grupo = contrato.grupo;
    _contratoItemToAdd.origem = origin;
    _contratoItemToAdd.projeto = projeto?.nome || '';
    let sku: number = Number(localStorage.getItem("UnidadeArmazenamentoSel"));
    if (sku > 0) {
      setICSKU(sku);
      _contratoItemToAdd.idSku = sku.toString();
    }
    var parceiro: Parceiro = JSON.parse(String(localStorage.getItem("ParceiroSelecionado")));
    let centro: number = Number(localStorage.getItem("centroVirualSel"));
    if (centro > 0) {
      setICENTRO(centro);
      _contratoItemToAdd.centroDistribuicaoDestino = centro;
    }
    _contratoItemToAdd.anoRef = ICANO;
    _contratoItemToAdd.quantidade = ICQTDE ? toNumber(ICQTDE) : 0;
    _contratoItemToAdd.contratoSap = contratoSap;
    _contratoItemToAdd.d_E_L_E_T_E = false;
    _contratoItemToAdd.criadoEm = new Date();
    _contratoItemToAdd.excluidoEm = new Date();
    setContratoItem(_contratoItemToAdd);
    if (_contratoItemToAdd.id === 0) {
      handleClose();
      dataContratoItem.Adicionar(_contratoItemToAdd).then(() => {
        dataContratoItem.ListarAtivos(String(contrato.numeroContrato), Number(contrato.codigoFornecedorSAP)).then(response => {
          dataContratoItem.AdicionarListaAoCache(response);
        }).finally(() => {
          Mensagem(t("pages.contracts.text.addItemToContract"), t("pages.contracts.text.contractItemUpdateWithSuccess"));
        })
      });
    }
    // PageHelper.refreshPage();
  };

  const handleForecastClick = () => {
    setLoading(true);
    setGerouForecast(true);
    dataForecast.DetalharAno(contrato).then((response) => {
      setLoading(false);
      if (response) {
        Mensagem(t("pages.contracts.text.generateMonthlyForecast"), `${t("pages.contracts.text.contractForecast")}: ${contrato.numeroContrato} ${t("pages.contracts.text.forPartner")} ${contrato.grupo} ${t("pages.contracts.text.generatedWithSuccess")}`);
      }
    }).catch(() => {
      setLoading(false);
    });
  };

  const handleBack = () => {
    navigate('/planejamento/contratos');
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
      <div className={`container ${styles.container}`}>
        <div className="containerTitle">
          <ContratoTopo title={t('pages.contracts.text.contractDetails')} />
        </div>
        <div className="containerToolbar">
          <Tooltip title={t("pages.contracts.text.saveContract")}>
            <span>
              <IconButton
                onClick={VerifyDataVigencia}
                disabled={user.isParceiro || user.isSuporte}
              >
                <SaveIcon /></IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t("common.back")}>
            <IconButton onClick={handleBack}>
              <AssignmentReturn />
            </IconButton>
          </Tooltip>

          {!gerouForecast ? (
            <Tooltip title={t("pages.contracts.text.excludeContract")}>
              <span>
                <IconButton
                  onClick={handleOpenDialogDelete}
                  disabled={user.isParceiro || user.isSuporte}
                > <EraseIcon />
                </IconButton>
              </span>
            </Tooltip>
          ) : (null)}
          {false && contrato.id.valueOf() > 0 && contrato.itensContrato.length > 0 && !gerouForecast ? (
            <React.Fragment>
              <Tooltip title={t("pages.contracts.text.generateMonthlyForecast")}>
                <span>
                  <IconButton
                    onClick={handleForecastClick}
                    disabled={loading || user.isParceiro || user.isSuporte}
                  > <AppsIcon /> </IconButton>
                </span>
              </Tooltip>
            </React.Fragment>
          ) : (null)}
        </div>
        <div className="insiderContainer">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={2}>
              <TextField
                required
                id={"contrato" + contrato.numeroContrato}
                name={"contrato" + contrato.numeroContrato}
                label={t("pages.contracts.text.contractNumber")}
                variant="outlined"
                value={contrato.numeroContrato}
                fullWidth
                size="small"
                onChange={handlerNumeroContratoChange}
                onBlur={handlerLostFocusContrato}
                // disabled={contrato.id.valueOf() > 0} TODO: All the contracts are disabled?
              //error={erroContrato}
              />
            </Grid>
            {/* <Grid item xs={12} sm={2}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="selectprojeto">{'Projeto'}</InputLabel>
                  <Select
                    labelId="selectprojeto"
                    id="selectprojeto"
                    value={contrato.projeto}
                    label={'Projeto'}
                    onChange={handlerProjetoChange}
                    size="small"
                  >
                    {projetos.map((projeto) => (
                      <MenuItem key={String(projeto.id)} value={projeto.nome}>{projeto.nome}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid> */}
            <Grid item xs={12} sm={2}>
              <TextField
                required
                id={"contrato" + contrato.freqAtualPrecM.toString()}
                name={"contrato" + contrato.freqAtualPrecM.toString()}
                label={t("pages.contracts.text.priceFrequency")}
                fullWidth
                variant="outlined"
                value={contrato.freqAtualPrecM}
                onChange={handlerFrequenciaChange}
                size="small"
                //error={erroPreco}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                required
                id={"contrato" + contrato.multaAcordada}
                name={"contrato" + contrato.multaAcordada}
                label={t("pages.contracts.text.agreedPenalty")}
                placeholder={t("pages.contracts.text.penalty")}
                title={t('pages.contracts.text.titlePenalty')}
                fullWidth
                variant="outlined"
                value={multaAcordada}
                onChange={handlermultaAcordadaChange}
                size="small"
              //error={erroMulta}
              />
            </Grid>
            <Grid item xs={12} sm={2} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label={t("pages.contracts.text.beginningOfTerm")}
                  inputFormat="dd/MM/yyyy"
                  value={contrato.inicioVigencia}
                  onChange={(newValue: any) => {
                    if (newValue) {
                      handlerInicioVigenciaChange(new Date(newValue));
                    }
                  }}
                  renderInput={(params: any) => <TextField size="small" {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={2} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label={t("pages.contracts.text.endOfTerm")}
                  inputFormat="dd/MM/yyyy"
                  value={contrato.finalVigencia}
                  onChange={(newValue: any) => {
                    if (newValue) {
                      handlerFimVigenciaChange(new Date(newValue));
                    }
                  }}
                  renderInput={(params: any) => <TextField {...params} size="small" />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={1}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="selectfrete">{t("pages.contracts.text.shippingMode")}</InputLabel>
                  <Select
                    labelId="selectfrete"
                    id="selectfrete"
                    value={contrato.modalidadeFrete}
                    label={t("pages.contracts.text.shippingMode")}
                    onChange={handlerFreteChange}
                    size="small"
                    //   error={erroFrete}
                  >
                    <MenuItem value={""}></MenuItem>
                    <MenuItem value={"CIF"}>CIF</MenuItem>
                    <MenuItem value={"FOB"}>FOB</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} sm={1}>
              {contrato.id.valueOf() > 0 ? (
                <Tooltip title={t("pages.contracts.text.addItemsToContract")}>
                  <span>
                    <IconButton sx={{ backgroundColor: "#884DFF", color: "white" }}
                      onClick={handleOpen}
                      disabled={user.isParceiro || user.isSuporte}
                    >
                      <PlaylistAdd />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : (null)}
            </Grid>
          </Grid>
        </div>
        <div className={`insiderContainer ${styles.table}`} style={{ display: 'flex' }}>
          <ContratoItemGrid />
        </div>

        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className='containerModal'>
              <div className="containerTitleModal"><TopoItemContrato /></div>
              <div className="containerToolbarModal">
                <Tooltip title={t("pages.contracts.text.updateContractItem")}>
                  <IconButton onClick={modalSalvar}>
                    <SaveIcon />
                  </IconButton>
                </Tooltip>
                {contrato.id.valueOf() > 0 && contrato.itensContrato.length > 0 ? (
                  <React.Fragment>
                    <Tooltip title={t("pages.contracts.text.modalExit")}>
                      <IconButton onClick={handleClose}> <ExitToAppIcon /> </IconButton>
                    </Tooltip>
                  </React.Fragment>
                ) : (null)}
              </div>
              <div className='insiderContainerModal'>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={11}>
                    <AutocompleteSku />
                  </Grid>
                  <Grid item xs={12} sm={11}>
                    <AutocompleteCentroCentroVirtual />
                  </Grid>
                  <Grid item xs={12} sm={11}>
                    <TextField
                      required
                      id={"contratoItem" + contratoItem.anoRef.toString()}
                      name={"contratoItem" + contratoItem.anoRef.toString()}
                      label={t("pages.contracts.text.yearReference")}
                      variant="outlined"
                      fullWidth
                      value={ICANO}
                      onChange={handlercontratoItemanoRefChange}
                      size="small" />
                  </Grid>
                  <Grid item xs={12} sm={11}>
                    <TextField
                      required
                      id={"contratoItem" + contratoItem.quantidade}
                      name={"contratoItem" + contratoItem.quantidade}
                      label={t("pages.contracts.text.anualQuantity")}
                      variant="outlined"
                      fullWidth
                      value={ICQTDE}
                      onChange={handlercontratoItemQuantidadeChange}
                      size="small" />
                  </Grid>
                  <Grid item xs={12} sm={11}>
                    <FormControl fullWidth>
                      <InputLabel id="selectprojeto">{t("pages.contracts.text.project")}</InputLabel>
                      <Select
                        labelId="selectprojeto"
                        id="selectprojeto"
                        value={projeto?.nome}
                        label={t("pages.contracts.text.project")}
                        onChange={handlerProjetoChange}
                        size="medium"
                      >
                        {projetos.map((projeto) => (
                          <MenuItem key={String(projeto.id)} value={projeto.nome}>{projeto.nome}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Modal>
        </div>
        <div>
          <Dialog
            open={openDialogDelete}
            onClose={handleCloseDialogDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {t("pages.contracts.text.excludeItemQuestionTitle")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("pages.contracts.text.excludeItemQuestionSubTitle")}<br /><br />
                {t("pages.contracts.text.contractNumber")}: <strong>{contrato.numeroContrato}<strong /></strong><br />
                {t("pages.contracts.text.excludeItemQuestionConfirmation")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="error" onClick={() => {
                ExcluirContrato();
              }}>
                {t("common.yes")}
              </Button>
              <Button variant='outlined' color="success" onClick={handleCloseDialogDelete} autoFocus>
                {t("common.no")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </LocalizationProvider>
  )
}